import driverModule from "./driverModule"
import driverView from "./driverView.html"

driverModule.config(["editionServiceProvider", (editionServiceProvider) => {
    editionServiceProvider.registerEdition("driver", driverView, "driverController")
}])